export const editorActionTypes = {
    SET_VALUE: 'SET_VALUE',
    SET_SAVE_CURRENT_VALUE: 'SET_SAVE_CURRENT_VALUE',
    SET_SAVE_CURRENT_VALUE_GIT: 'SET_SAVE_CURRENT_VALUE_GIT',
    SET_CURRENT_BRANCH: 'SET_CURRENT_BRANCH',
    SET_CURRENT_VALUE_INFO: 'SET_CURRENT_VALUE_INFO'
}